import { forwardRef, type PropsWithChildren } from "react";

import { cn } from "$/lib/utils/functions/misc.functions";

import type { AvatarProps } from "./Avatar.types";

const Avatar = forwardRef<HTMLImageElement, PropsWithChildren<AvatarProps>>(
  ({ size = "large", ...avatarProps }, forwardedRef) => {
    return (
      <img
        ref={forwardedRef}
        className={cn("rounded-lg", {
          "h-12 w-12": size === "large",
          "h-16 w-16": size === "extraLarge",
        })}
        {...avatarProps}
      />
    );
  },
);

Avatar.displayName = "Avatar";

export default Avatar;
